module.exports = __webpack_public_path__ + "img/pic4.d617f433.png";